var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/17fd865a58e29b4b5308a81b8e65ac35.js').default;export default
        Object.assign({}, scope_0 )
    